import React from 'react'
import PropTypes from 'prop-types'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('container')

export default function Container ({ children }) {
  return (
    <div {...classes('')}>{children}</div>
  )
}

Container.propTypes = {
  children: PropTypes.any.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Container/index.js